import styles from './NotFound.module.scss';

export default function NotFound() {
    return (
        <section className={styles.notfound_container}>
            <div className={styles.notfound_box}>
                <h2>Página Não Encontrada</h2>
            </div>
        </section>
    );
}
